<template>
  <div id="map" style="height: 88%;width:100%; margin-left: 5px;margin-top: 5px;position: relative;"></div>
</template>

<script>
import L from 'leaflet';

export default {
  name: 'UeGpsMap',
  data() {
    return {
      map: null,
      centerCache: localStorage.getItem('mapCenter') ? JSON.parse(localStorage.getItem('mapCenter')):null,
      mapConfig: {
        longitude: this.centerCache ? this.centerCache.longitude : 0,
        latitude: this.centerCache ? this.centerCache.latitude : 0,
        defaultZoom: this.centerCache ? this.centerCache.defaultZoom : 13,
        maxZoom: this.centerCache ? this.centerCache.maxZoom : 15,
        minZoom: this.centerCache ? this.centerCache.minZoom : 2
      },
      eqInfo: [],
      ueInfo: [],
      bsLayers:[],
      ueLayers:[],
      bgGroup: null,
      ueGroup: null,
    };
  },
  methods: {

    /**
     * 决定初始化地图是否可以移动
     */
    init() {

      this.initMapView();
      this.initMap();
      this._createLegend();
      this._mapTrigger();
    },
    /**
     * 查询所有基站信息
     */
    markEquipments(data) {
      this.eqInfo = data;
      this._drawPoint(this.eqInfo, 1);
    },
    /**
     * 查询所有在线的UE信息
     */
    markOnlineUe(data) {
      this.ueInfo = data;
      this._drawPoint(this.ueInfo, 2)
    },
    /**
     * 初始化地图方法
     */
    initMap() {
      const webUrl = '/UniNM/map/{z}/{x}/{y}.png';
      const mapLayer = L.tileLayer(webUrl);
      if(this.map == null){
        this.map = L.map('map', {
          layers: [mapLayer],
          maxZoom: this.mapConfig.maxZoom,
          minZoom: this.mapConfig.minZoom,
          scrollWheelZoom: true,   // 支持滚轮缩放
          dragging: true,
          animate: true,
          doubleClickZoom:false,
          keyboardPanDelta: 100,    // 按键盘时平移的像素
          attributionControl: false,
        }).setView([this.mapConfig.latitude, this.mapConfig.longitude], this.mapConfig.defaultZoom);
      }
    },

    /**
     * 初始化第一次加载地图显示上次定位位置
     */
    async initMapView() {
      const centerCache = localStorage.getItem('mapCenter');
      console.log("local cache get map center is:"+centerCache);
      if(centerCache){
        this.mapConfig = JSON.parse(centerCache);
      }else{
        await this.$axios.post('/lte/ems/sysmanager/map/queryConfig').then((response) => {
          const mapConf = response.data;
          this.mapConfig.latitude = mapConf.centerLatitude;
          this.mapConfig.longitude = mapConf.centerLongitude;
          this.mapConfig.maxZoom = mapConf.maxZoom;
          this.mapConfig.minZoom = mapConf.minZoom;
          this.mapConfig.defaultZoom = mapConf.defaultZoom;
          localStorage.setItem('mapCenter', JSON.stringify(this.mapConfig));
        });
      }
    },

    _mapTrigger(){
      //监控地图移动，获取移动后的中心点信息
      this.map.on("moveend",(ev) => {
        const targerCenter = this.map.getCenter();
        this.mapConfig.latitude = targerCenter.lat;
        this.mapConfig.longitude = targerCenter.lng;
        this.mapConfig.maxZoom = this.map.getMaxZoom();
        this.mapConfig.minZoom = this.map.getMinZoom();
        this.mapConfig.defaultZoom = this.map.getZoom();
        localStorage.setItem("mapCenter", JSON.stringify(this.mapConfig));
      });
    },
    _drawPoint(infos, flag) {
      const iconArr = [];
      if(flag == 1){
        const bsOnIcon = L.divIcon({
          html: "<div class='bs-on'></div>",
          className: 'online',});
        const bsFreeIcon = L.divIcon({
          html: "<div class='bs-free'></div>",
          className: 'offline',});
        iconArr.push(bsOnIcon);
        iconArr.push(bsFreeIcon);
        if(this.bsGroup != null){
          this.bsGroup.clearLayers();
          this.bsLayers = [];
        }
      }else{
        const ueOnIcon = L.divIcon({
          html: "<div class='ue-on'></div>",
          className: 'online',});
        const ueFreeIcon = L.divIcon({
          html: "<div class='ue-free'></div>",
          className: 'offline',});
        iconArr.push(ueOnIcon);
        iconArr.push(ueFreeIcon);
        if(this.ueGroup != null){
          this.ueGroup.clearLayers();
          this.ueLayers = [];
        }
      }
      if(infos.length > 0){
        infos.forEach((item) =>{
          if(item.latitude == null || item.latitude ==''){
            return true;
          }
          if(item.longitude == null || item.longitude == ''){
            return true;
          }
          let html = this._createLayer(item, flag);
          let marker = L.marker([item.latitude, item.longitude],{ icon: (item.state == 0 ? iconArr[0] : iconArr[1])}).bindPopup(html);
          if(flag == 1){
            this.bsLayers.push(marker);
          }else{
            this.ueLayers.push(marker);
          }
        });
        if(flag == 1){
          this.bsGroup = L.layerGroup(this.bsLayers);
          this.map.addLayer(this.bsGroup);
        }else{
          this.ueGroup = L.layerGroup(this.ueLayers);
          this.map.addLayer(this.ueGroup);
        }
      }
    },
    _createLayer(info, flag){
      let html = "";
      if(flag == 1){
        html = "<b>"+this.$t('UE.ue_bs_id')+":"+info.eqId+"</b><br>";
        if(info.eqAlias != ""){
          html += "<b>"+this.$t('UE.ue_bs_name')+":"+info.eqAlias+"</b><br>";
        }
      }else{
        html = "<b>"+this.$t('UE.ue_imsi')+":"+info.imsi+"</b><br>";
        if(info.ueAlias != ""){
          html += "<b>"+this.$t('UE.ue_alias')+":"+info.ueAlias+"</b><br>";
        }
        if(info.eqAlias != ""){
          html += "<b>"+this.$t('UE.ue_base_enodeb')+":"+info.eqAlias+"</b><br>";
        }
        if(info.ip4 != ""){
          html += "<b>IP:"+info.ip4+"</b><br>";
        }
      }
      html += "<b>"+this.$t('UE.latLng')+":["+info.latitude+","+info.longitude+"]</b><br>";
      return html;
    },
    _createLegend(){
      const This = this;
      L.Control.Legend = L.Control.extend({
        options: {
          position: 'bottonleft' //初始位置

        },
        initialize: function (options) {
          L.Util.extend(this.options, options);

        },
        onAdd: function (map) {
          this._container = L.DomUtil.create('div');
          //创建一个图片要素
          this._container.innerHTML = '<div class="ue-custom-legend" ><span>'+This.$t('UE.legend')+':</span><li><div class="legend-ue"></div><span >'+This.$t('UE.legend_ue')+'</span></li><li style="border-right:2px solid #ccc;"><div class="legend-bs"></div><span>'+This.$t('UE.legend_bs')+'</span></li><li><div class="legend-off"></div><span>'+This.$t('UE.ue_state_idle')+'</span></li><li><div class="legend-on"></div><span>'+This.$t('UE.ue_state_up')+'</span></li></div>';
          return this._container;
        },
      });
      L.control.legend = function (opts) {
        return new L.Control.Legend(opts);
      };
      //添加图例
      L.control.legend({ position: 'bottomleft' }).addTo(this.map);
    },

  },
  mounted() {
    this.init();
  }
}
</script>

<style scoped>
@import '~leaflet/dist/leaflet.css';

</style>
